/**
 * The Claro iPhone app on the App Store.
 *
 * No region segment — Apple redirects the reader to their own storefront.
 * Hardcoding /au/ would send a US clinician to a store they cannot install
 * from. Same URL as the welcome email (Claro.Emails.WelcomeEmails).
 */
export const APP_STORE_URL = 'https://apps.apple.com/app/id6760515643'
